module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-search",
    attrs: {
      "id": "gv-search"
    }
  }, [_vm._c('el-select', {
    attrs: {
      "id": "gv-seach-input",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "size": "mini",
      "placeholder": _vm.placeHolder,
      "remote-method": _vm.search,
      "loading": _vm.loading,
      "loading-text": "Caricamento... ",
      "no-match-text": "Nessun elemento trovato",
      "no-data-text": "Nessun elemento trovato"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, _vm._l((_vm.results), function(item) {
    return _vm._c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9c4e320!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 913
// module chunks = 39